import React, { FC } from 'react';
import { DateObj } from 'dayzed';
import { DateRangeRenderProps } from '../../types';
import styled from '@emotion/styled';
import { Box, NakedButton } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import * as images from 'images';

export interface CalendarCellProps extends DateRangeRenderProps {
  dateObj: '' | DateObj;
}

export const CalendarCell: FC<CalendarCellProps> = ({ dateObj, ...rest }) => {
  return (
    <Square flex="1 1 auto" width="calc(100%/7)" position="relative" border="1px solid transparent" mt="0" mr="-1px" mb="-1px" ml="0">
      {dateObj ? <DateCell dateObj={dateObj} {...rest} /> : null}
    </Square>
  );
};

interface DateCellProps extends DateRangeRenderProps {
  dateObj: DateObj;
}

const DateCell: FC<DateCellProps> = ({ dateObj, getDateProps }) => {
  return <DateButton {...getDateProps(dateObj)}>{dateObj.date.getDate()}</DateButton>;
};

const Square = styled(Box)`
  ::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

const DateButton = styled(NakedButton)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: ${themeGet('colors.greys.charcoal')};
  padding: 0;
  border: ${themeGet('borders.1')} transparent;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${themeGet('colors.greys.alto')};
  }

  &[data-variant='selectable'] {
    background-color: ${themeGet('colors.white')};

    &:hover,
    &:focus {
      background-color: ${themeGet('colors.white')};
      border-color: ${themeGet('colors.brand.secondary')};
    }
  }

  &[data-variant='start'] {
    background-image: url(${images.startDate});
  }

  &[data-variant='end'] {
    background-image: url(${images.endDate});
  }

  &[data-variant='start'],
  &[data-variant='end'] {
    background-color: ${themeGet('colors.lightBlue')};
    background-size: cover;
    background-repeat: no-repeat;

    &:hover,
    &:focus {
      background-color: ${themeGet('colors.lightBlue')};
    }
  }

  &[data-variant='highlighted'] {
    background-color: ${themeGet('colors.lightBlue')};

    &:hover,
    &:focus {
      background-color: transparent;
      border-color: ${themeGet('colors.brand.secondary')};
    }
  }

  &[data-variant='disabled'],
  &[data-variant='blocked'] {
    background-color: ${themeGet('colors.greys.alto')};

    &:hover,
    &:focus {
      background-color: ${themeGet('colors.greys.dusty')};
    }
  }
`;
